<div class="holiday-card-container mat-card">
    <div class="holiday-card-title">
        <span>{{holiday.holidayName}}</span>
    </div>
    <div class="holiday-card-body">
        <div>{{getMonthTranslation(holiday.holidayDate | date :'MMMM')}}{{holiday.holidayDate | date :' d' }}
            <span *ngIf="holiday.dayType === 'HALF'">
                (
                <span *ngIf="holiday.dayTime === 'AM'">{{ 'common.fullDay' | translate }}</span>
                <span *ngIf="holiday.dayTime === 'PM'">{{ 'common.halfDay' | translate }}</span>
                )
            </span>
        </div>
        <div class="recurring-con">
            <ng-container *ngIf="holiday.isRecurring">
                <span>
                    <asp-icon name="ic-20-utility-update-small-recurring.svg" width="1rem" height='1rem' color='var(--primary-toyota-color)'></asp-icon>
                </span>
                {{ 'departmentHolidays.recurringYearly' | translate }}
            </ng-container>
        </div>
    </div>
    <div class="holiday-card-action">
        <div (click)="deleteHoliday(holiday.holidayId)" class="mr"><asp-icon name="ic-20-utility-delete-trash.svg" width="1rem" height='1rem' color='rgba(14,19,25,0.8)'></asp-icon></div>
        <div  (click)="updateHoliday(holiday)"><asp-icon name="ic-20-utility-edit.svg" width="1rem" height='1rem' color='rgba(14,19,25,0.8)'></asp-icon></div>
    </div>
</div>
